export default __webpack_public_path__ + "static/media/what-we-provide-ip-icon.903cb68b.svg";